import React, {  useContext, useEffect, useRef, useState } from "react";
import './styles.scss';
import { Checkbox, CheckboxProps,   Col,   Form, Input, InputNumber, Modal, Row, Select, Button } from "antd";
import { DepositExtractionFormProps, FilterValues, inputsForms, OperationData, OperationDataInSuppliers } from "./types";
import { useGetAllClients } from "../../../Services/useGetAllClients";
import { useGetCashDesk } from "../../../Services/useGetCashDesk";
import { useOperations } from "../../../Services/useOperations";
import { VariablesContext } from "../../../Contexts/UserContext/VariablesContext";
import { ResponseAccounts, useAccounts } from "../../../Services/useAccounts";
import { useGetBranch } from "../../../Services/useGetBranch";
import { Transaction } from "../../../Services/useGetMovements";
import ModalTitle from "../../ModalTitle";
import { OperationsContext } from "../../../Contexts/UserContext/OperationsContext";
import NewCustomer from "../../NewCustomer";


export const DepositExtractionForm: React.FC<DepositExtractionFormProps> =({
    form,     
    showAddMovements,
    setShowAddMovements,
    checkoutsMovements,
    setCheckoutsMovements,
    values,
    supplierTransactions,
    results: accountResult,    
})=>{
    
    const { data: clients } = useGetAllClients()
    const { data: cashs } = useGetCashDesk()
    const { setRowSelect } = useContext(OperationsContext)    
    const { collapsedFilsters, setCollapsedFilters, dataTransactionsToForm: transactions, setDataTransactionsToForm
        //setSelectedRowId, 
        //selectedRowId
    } = useContext(VariablesContext)
    const { setShowForms, showForms } = useContext(VariablesContext)
    const { createOperation, editOperation, getOperation } = useOperations()
    const { getAccountsCurrencyAndCustomer } = useAccounts()  
    const { Option } = Select;
    const {data: branches } = useGetBranch()
    const inputRef = useRef<any>(null);
    const inputRefPorcentage = useRef<any>(null);

    const filtered = [
        {
            label: 'Depósito en cuenta corriente cliente',
            key: 1, 
        },
        {
            label: 'Extracción en cuenta corriente cliente',
            key: 2, 
        }
    ]
    const [ loadingBtn, setLoadingBtn ] = useState(false)
    const [ aproved, setAproved ] = useState(false)
    const [ clientPayCost, setClientPayCost ] = useState(false)
    const [ withComission, setWithComission ] = useState(false)
    const [ operationType, setOperationType ] = useState<number | undefined>()
    const [ spanError, setSpanError ] = useState<string>()
    const [ client, setClient ] = useState<number | undefined>()
    const [ currency, setCurrency ] = useState<{id: number, sign: string} | undefined>()
    const [ balance, setBalance ] = useState<ResponseAccounts>()
    const [ amountInput, setAmountInput] = useState<number>()
    const [results, setResults] = useState<number>()
    const [costBank, setCostBank] = useState<number>(0)
    const [typeTrasnfer, setTypeTransfer] = useState<'deposit' | 'extraction'>()
    //const [transactionsData, setTransactionsData] = useState<Transaction>()
    const [branchSelected, setBranchSelected] = useState<number | undefined>()  
    const [isFixedCommission, setIsFixedCommission] = useState<boolean>(false)
    const [disabledForm, setDisableForm] = useState<{
        disable: boolean,
        approved: boolean,
        deleted: boolean,
        operationNumber: number | undefined
    }>({
        disable: false,
        approved: false,
        deleted: false,
        operationNumber: undefined
    })

    const mandatory = [
        {
            required: true,
            message:'Este campo es obligatorio'
        }
    ]  

    const fixedCommission = Form.useWatch('fixed_commission', form); //el valor se actualiza cada vez que se modifica el input del form
    const commission = Form.useWatch('commission', form); //el valor se actualiza cada vez que se modifica el input del form
  
    useEffect(() => {
        if(values){
            uploadFormWhitValues()
        }else if(transactions){
            uploadForm(transactions) 
        }else{
            form.resetFields(undefined) 
            form.setFieldsValue({ commission: 3 });
            setTypeTransfer(undefined)
        }       
    }, []);

    useEffect(()=>{
        if(currency && currency?.id && client ){            
            getBalance()
        }    
    },[currency, client])

    useEffect(()=>{
        if (
            amountInput != undefined &&
            costBank != undefined 
        ){           
            if(typeTrasnfer === 'deposit'){
                let result = 0
                if(isFixedCommission){
                    result = clientPayCost ? amountInput - fixedCommission - costBank : amountInput - fixedCommission
                }else{
                    result = clientPayCost
                        ? Number(amountInput)-(amountInput*(commission/100))-Number(costBank)
                        : Number(amountInput)-(amountInput*(commission/100))    
                }
                
                setResults((result))
            }
            if(typeTrasnfer === 'extraction'){
                let result = 0
                if(isFixedCommission){
                    result = clientPayCost ? amountInput + fixedCommission - costBank : amountInput + fixedCommission
                }
                else{  
                    result = clientPayCost
                        ? (amountInput*(1+commission/100))+Number(costBank)
                        : (amountInput*(1+commission/100))
                }
                setResults(-(result))
            }            
        }
    },[amountInput, commission, typeTrasnfer, costBank, clientPayCost, withComission, fixedCommission])


    useEffect(()=>{
        if(amountInput){
            if(balance && (operationType===2 || operationType===4)){ //depósitos
                if( amountInput > balance.balance ){            
                    let value = new Intl.NumberFormat('es-AR', { style: 'decimal', minimumFractionDigits: 2 }).format(balance.balance)
                    setSpanError('La extraccón supera el monto de cuenta: ' + currency?.sign + ' ' + value  )  
                }
            }else{
                if(spanError){
                    setSpanError(undefined)
                }
            }
        }        
    },[balance])

    const handleCancel =()=>{
        setLoadingBtn(false)
        if(setShowAddMovements && !supplierTransactions?.approved){ //Si viene, es porque es el formuilario del modal de proveedor, sino, es el del menú
            setShowAddMovements(false)
        }else{
            setShowForms(Object.fromEntries(Object.keys(showForms).map(key => [key, false])))// pone todos en false
        }
        if(transactions){
            if(!setShowAddMovements){
                setDataTransactionsToForm(undefined) 
            }  
        }       
        setRowSelect(undefined) 
    }

    const getBalance = async() =>{  
        if(client){
            const data = await getAccountsCurrencyAndCustomer(client, Number(currency?.id))
            if(data){
                setBalance(data)
    
            }
        }                             
    }

    const uploadFormWhitValues = () =>{
        if(values){
            setDisableForm({
                disable: values.approved_db || values.deleted ? true : false,
                approved: values.approved_db || false,
                deleted: values.deleted || false,
                operationNumber: values.operation_id
            })
            let ammount_data: number | undefined
            let cash_data: number | undefined
            let branch: number | undefined

            switch(values.type_id){
                case 1: // Deposito
                    cash_data = values.destination_checkout_id
                    ammount_data= Number(values.credit)
                    break;
                case 2: //extracción
                    cash_data =  values.origin_checkout_id
                    ammount_data = Number(values.debit)
                    break;                 
            }
            //setTransactionsData(response)
            if(cash_data){
                branch = cashs.find((x)=>x.id == cash_data)?.branch.id
            }
            if(values.currency){
                let cash = cashs.find((cash)=> cash.currency.id === Number(values.currency))
                cash && setCurrency({id: cash.currency.id, sign: cash.currency.sign})                 
            }
            if(values.approved){
                setAproved(values.approved) 
            }
            
            if(values?.type_id === 1){
                setTypeTransfer('deposit')                    
            }else if(values?.type_id === 2){
                setTypeTransfer('extraction')
            }            
            setClient(values.customer_id) 
                                        
            form.setFieldsValue({
                operation_type: values.type_id,
                client: Number(values?.customer_id) || undefined,                    
                comission:  undefined,
                branch_cahs_extraction: branch,
                cash: cash_data,
                amount: ammount_data && Number(ammount_data?.toFixed(2)),
                description: undefined,
                transfer_costs: undefined,
                client_pays_costs: undefined                      
            });   
          
            setAmountInput(ammount_data)                                                 
        }
    }

    const uploadForm = async(response: Transaction) =>{
        
        setDisableForm({
                disable: (response?.approved || response?.deleted) ? true : false,
                approved: response?.approved || false,
                deleted: response?.deleted || false,
                operationNumber: response?.operation_id || undefined
            })

        let cash_data
        let amount_data
        let operation_type  

        //setTransactionsData(response)
        setAproved(response.approved) 
        
        if(response?.type.id === 1 || response?.type.id === 3){
            setTypeTransfer('deposit')                    
        }else if( response?.type.id === 2 || response?.type.id === 4){
            setTypeTransfer('extraction')
        }

        if(response.fixed_commission){
            setIsFixedCommission(true)
            form.setFieldsValue({ fixed_commission: response.fixed_commission });
        }else{
            form.setFieldsValue({ fixed_commission: 0 });
        }
        if(response.commission){
            form.setFieldsValue({ commission: response.commission });
        }
        
        setClient(response.customer.id)
        setCostBank(response.transfer_costs  ? response.transfer_costs : 0)
        setClientPayCost(response.client_pays_costs || false)              
        
        switch(response.type.id){
            case 1: // Depósito efectivo
            case 3: // Depósito bancario
                operation_type = 1
                let cash_destination = cashs.find((cash)=> cash.id===response.destination_checkout.id)

                cash_data =  response.destination_checkout.id                 
                amount_data = response.credit 
                
                if(cash_destination){
                    setCurrency({id: cash_destination.currency.id, sign: cash_destination.currency.sign}) 
                }                                       
                setAmountInput(response.credit)
                if(response.destination_checkout.branch.id){
                    setBranchSelected(response.destination_checkout.branch.id)
                }
                form.setFieldsValue({
                    branch_cahs_extraction: response.destination_checkout.branch.id
                })
                break;
            case 2: // Extracción efectivo
            case 4:  // Extracción Bancaria
                operation_type = 2
                let cash_origin = cashs.find((cash) => cash.id===response.origin_checkout?.id); 
                cash_data = response.origin_checkout?.id        
                amount_data = response.debit;

                cash_origin && setCurrency({ id: cash_origin.currency.id, sign: cash_origin.currency.sign });
                
                setAmountInput(response.debit);
                if(response.origin_checkout.branch.id){
                    setBranchSelected(response.origin_checkout?.branch?.id)
                }
                form.setFieldsValue({
                    branch_cahs_extraction: response.origin_checkout?.branch?.name,
                })
                
                break;
            default:
                break
        }
        switch(response.type.id){
            case 3:
            case 4:
                setWithComission(true)
                break;
            case 1:
            case 2:
                setWithComission(false)
        }   
                        
        if(cash_data && operation_type){                  
            form.setFieldsValue({
                operation_type: operation_type,
                client: response.customer.id,                    
                comission:  response.commission,
                cash: cash_data,
                amount: amount_data,
                description: response.description,
                transfer_costs: response.transfer_costs,
                client_pays_costs: response.client_pays_costs                      
            });  
        }  
                
        setAmountInput(Number(amount_data))                              
                                            
    }

    const confirmSave = async(operationData: OperationData, id?: string | undefined)=>{        
        let newData
        if(id){
            newData = await editOperation(handleCancel, id, operationData)
        }else{
            newData = await createOperation(handleCancel, operationData)
        } 
        setCollapsedFilters(!collapsedFilsters)                    
    }

    const handleSave = async (e: inputsForms)=>{
        //setLoadingBtn(true)
        let operationData: OperationData | undefined; 
        switch (e.operation_type) {
            case 1: // Depósito efectivo
                operationData = {                                     
                    description: e.description,
                    type_id:  withComission ? 3 : 1,
                    destination_checkout_id: e.cash,
                    customer_id: e.client,
                    credit: Number(e.amount),  
                    approved: aproved,
                    transfer_costs: e.transfer_costs ? Number(e.transfer_costs) : undefined, 
                    client_pays_costs: clientPayCost,                                                                            
                };
                if(withComission){
                    if(isFixedCommission){
                        operationData.fixed_commission = withComission && isFixedCommission ? fixedCommission : undefined
                    }else{
                       operationData.commission = Number(e.commission); 
                    }                    
                }                                
                break;
            case 2: // Extracción efectivo
                operationData = {
                    description: e.description,
                    type_id: withComission ? 4 : 2,                
                    origin_checkout_id: e.cash,
                    customer_id: e.client,
                    debit: Number(e.amount),   
                    approved: aproved,     
                    transfer_costs: e.transfer_costs ? Number(e.transfer_costs) : undefined, 
                    client_pays_costs: clientPayCost,         
                };
                
                if(withComission){
                    if(isFixedCommission){
                        operationData.fixed_commission = withComission && isFixedCommission ? fixedCommission : undefined
                    }else{
                       operationData.commission = Number(e.commission); 
                    }                    
                }
                
                break;
            default:
                handleCancel()
                break;
        }                 

        if(operationData){
            if(setCheckoutsMovements && !supplierTransactions?.approved){                    
                if (values && values.id && checkoutsMovements) {
                    const updatedMovements = checkoutsMovements.map(item =>
                        item.id === values.id ? { ...item, ...operationData } : item
                    );
                    setCheckoutsMovements(updatedMovements);
                } else if(values?.key !== undefined && checkoutsMovements){
                    const updatedMovements = checkoutsMovements.map((item, index) =>
                        index === values.key ? { ...item, ...operationData } : item
                    );
                    setCheckoutsMovements(updatedMovements);
                }else{                    
                    let operationDataSuppliers: OperationDataInSuppliers = operationData
                    operationDataSuppliers.currency = cashs.find((x)=>x.id === e.cash)?.currency.id

                    let data = checkoutsMovements || [];
                    data.push(operationDataSuppliers);
                    setCheckoutsMovements(data);
                }
                handleCancel()
            }else{
                let customer = clients.find((x)=>x.id === e.client)
                Modal.confirm({
                    title: 'Confirmar operación',
                    okText: 'Confirmar',
                    cancelText: 'Cancelar',
                    onOk:()=> {
                        if(operationData){
                            if(supplierTransactions && supplierTransactions.approved && values?.id){
                                operationData.related_load_operation_id = supplierTransactions.id
                                confirmSave(operationData, values.id.toString())
                            }else{
                                if(transactions){
                                    confirmSave(operationData, transactions.id.toString()) 
                                }else{
                                    confirmSave(operationData)
                                }
                                
                            }                                                                       
                        }},
                    content: (
                        <div>
                            <p><strong>{filtered.find((t)=> t.key === e.operation_type)?.label }</strong></p>
                            {operationData.customer_id && <p><strong>Cliente: </strong> {customer?.first_name} {customer?.last_name}</p>}
                            <p><strong>Sucursal - Caja: </strong>{cashs.find((x)=>x.id === e.cash)?.branch.name} - {cashs.find((x)=>x.id === e.cash)?.name}</p>                                               
                            <p><strong>Monto: </strong>{currency && currency.sign} {Number(e.amount).toLocaleString("es-AR",{maximumFractionDigits:2, minimumFractionDigits:2})}</p>
                            {
                                operationData.commission && <p><strong>Comisión: </strong>{operationData.commission } %</p>
                            }
                            {
                                operationData.fixed_commission && <p><strong>Comisión: </strong>{currency?.sign} {operationData.fixed_commission.toLocaleString('es-AR', {maximumFractionDigits:2, minimumFractionDigits:2}) }</p>
                            }
                            {
                                (operationData.transfer_costs ?? 0) > 0 && (
                                    <p><strong>Costos bancarios: </strong>{currency?.sign} {operationData.transfer_costs}</p>
                                )
                            }
                            {
                                (operationData.transfer_costs ?? 0) > 0 && (
                                    <p><strong>Cliente paga los costos: </strong>{operationData.client_pays_costs ? 'Si' : 'No'} </p>
                                )
                            }
                            <p>
                                <strong>Estado: </strong>
                                <strong style={{ color: operationData.approved ? 'green' : 'orange' }}>
                                    {operationData.approved ? 'Aprobado' : 'Sin aprobar'}
                                </strong>
                            </p>                                                                                                                  
                        </div>
                    ),
                }); 
            }             
        }                             
    }       

    const changeTransferer = (e: number ) =>{
        setSpanError(undefined)
        setOperationType(e)        
        setAproved(false)
        setAmountInput(undefined)
        setResults(undefined)
        setWithComission(false)
        form.resetFields([
            'client', 
            'branch_cahs_extraction', 
            'cash', 
            'sell_currency', 
            'amount', 
            'commission', 
            'aproved', 
            'amount', 
            'description'
        ]);
        if(e === 1){
            setTypeTransfer('deposit')
        }else if (e===2){
            setTypeTransfer('extraction')
        }       
    }

    const onChangeClient = async(e: number) =>{
        setClient(e)        
    }

    const onChangeCash = async (e: number) =>{
        if(spanError){
            setSpanError(undefined)
        }
        let currency = cashs.find((x)=>x.id == e)?.currency   
        if(currency){
            setCurrency({id: currency.id, sign: currency.sign}) 
        }   
    }
 
    const onChangeAproved: CheckboxProps['onChange'] = async (e) => {
        setAproved(e.target.checked); 
    };

    const onChangePayCost: CheckboxProps['onChange'] = async (e) => {
        setClientPayCost(e.target.checked); 
    };

    const onChangeComissionCheck: CheckboxProps['onChange'] = async (e) => {
        form.resetFields([
            'commission',
            'transfer_costs'
        ]);
        setWithComission(e.target.checked); 
        form.setFieldsValue({ commission: 3 });
        form.setFieldsValue({ fixed_commission: 0 });
        setIsFixedCommission(false)
        setCostBank(0)
        setClientPayCost(false)       
         
    };

    const onChangeAmount = (e: string | null) =>{
        
        if(e){
            let value: number = Number(e)
            setAmountInput(value)
            if(balance && operationType === 2 ){ //depósitos
                if(value > balance.balance ){            
                    let value = new Intl.NumberFormat('es-AR', { style: 'decimal', minimumFractionDigits: 2 }).format(balance.balance)
                    setSpanError('La extraccón supera el monto de cuenta: ' + currency?.sign + ' ' + value  )  
                }else{
                    setSpanError(undefined)
                }
            }
        }
    }            

    // const onChangeComission = (value: number | null) => {       
    //     if (value !== null && value !== undefined) {
    //         setComission(value);
    //     }    
    // }

    const onChangeCostBank = (value: string | null) =>{       
        if(value || value == '0'){
            setCostBank(Number(value))
        }    
    }

    const handleRemove = () =>{
        if(values && setCheckoutsMovements && checkoutsMovements){
            let newList = checkoutsMovements?.filter((x)=> x.key !== values.key)            
            setCheckoutsMovements(newList)  
            handleCancel()                
        }        
    }

    const changePoint = (e:  React.KeyboardEvent<HTMLInputElement>)=>{
        const input = e.currentTarget as HTMLInputElement;
        const start = input.selectionStart ?? 0;
        const end = input.selectionEnd ?? 0;
        let newValue = input.value

        if (e.key === '.' && !e.shiftKey) {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }else if (e.key === ',') {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    }

    return(
        <div>
            <Modal
                style={{ top: 10 }}
                title= {
                    <ModalTitle 
                        title={'Depósito / Extracción: Cta cte clientes'} 
                        isApproved={disabledForm.approved ? true : false}
                        isDeleted={disabledForm.deleted ? true : false}
                        operationNumber={(disabledForm.disable && disabledForm.operationNumber) ? disabledForm.operationNumber : undefined}
                    />
                }
                open={showForms.deposit_extraction || showAddMovements}
                onCancel={handleCancel}  
                //confirmLoading={loadingBtn}                   
                okText="Guardar"
                cancelText="Cancelar" 
                onOk={()=>form.submit()}
                footer={
                    disabledForm.disable ? null : [
                        values && !values?.id && <Button key="extra" onClick={handleRemove}>Quitar de lista</Button>,
                        <Button key="cancel" onClick={handleCancel}>Cancelar</Button>,
                        <Button key="submit" type="primary" onClick={() => form.submit()}>Guardar</Button>
                    ]
                }
            >
                {
                    !disabledForm.disable &&
                    <NewCustomer justify={"end"} positions= {'leftTop'} />
                }
                <Form
                    form={form}
                    id='form_deposit_extraction'
                    onFinish={handleSave}
                    layout="vertical"
                    
                >                   
                    <Form.Item
                        label='Tipo de operación'
                        name='operation_type'                
                        rules={[
                            {
                                required: true,
                                message:'Este campo es obligatorio'
                            }
                        ]}
                        
                    >
                        <Select
                            disabled={disabledForm.disable || !!values}
                            placeholder="Seleccione el tipo de movimiento"   
                            onChange={changeTransferer}                         
                        >
                            {filtered && filtered.map((item) => (
                                <Option value={item.key} key={item.key} >
                                    {item.label}
                                </Option>
                            ))} 
                        </Select>
                    </Form.Item>                       
                    <Form.Item
                        label='Cliente'
                        name='client'
                        rules={[
                            {
                                required: true,
                                message:'Este campo es obligatorio'
                            }
                        ]}
                    >
                        <Select
                            disabled={disabledForm.disable || !!values} 
                            loading={!clients }
                            placeholder={!clients ? 'Cargando campos...' : 'Cliente'}      
                            style={{minWidth: '200px'}} 
                            showSearch   
                            onChange={onChangeClient} 
                            filterOption={(input, option) =>
                                (option?.children?.toString().toLowerCase() || '').includes(input.toLowerCase())
                            }                                 
                        >
                            {clients && clients.map((item) => (
                                <Option value={item.id} key={item.id} >
                                    {item.first_name + ' ' + item.last_name}
                                </Option>
                            ))} 
                        </Select>
                    </Form.Item> 
                    
                    <Row style={{ display: 'flex', gap: '10px', width: '100%' }}>
                        <Col style={{ flex: 1 }}>
                            <Form.Item
                                label='Sucursal'
                                name='branch_cahs_extraction'
                            >
                                <Select
                                    disabled={disabledForm.disable}
                                    style={{minWidth: 120}} 
                                    onChange={(e)=>{
                                        setBranchSelected(e)
                                        form.setFieldValue('cash', undefined)
                                    }}
                                    placeholder= 'Sucursal'
                                >
                                    {branches && branches.map((item) => (                                        
                                        <Option value={item.id} key={item.id}>
                                            {item.id === 0 ? 'EN TODAS' : item.name}
                                        </Option>
                                    ))} 
                                </Select> 
                            </Form.Item>
                        </Col>
                        <Col style={{ flex: 1 }}>
                            <Form.Item
                                label='Caja '
                                name='cash'
                                rules={[
                                    {
                                        required: true,
                                        message:'Este campo es obligatorio'
                                    }
                                ]}                                
                            >                            
                            <Select
                                disabled={disabledForm.disable}  
                                loading={!cashs }
                                placeholder={!cashs ? 'Cargando cajas...' : 'Seleccione una caja'}      
                                style={{minWidth: '200px'}}  
                                showSearch    
                                onChange={onChangeCash}       
                                filterOption={(input, option) =>
                                    (option?.children?.toString().toLowerCase() || '').includes(input.toLowerCase())
                                }             
                            >
                                {cashs && cashs
                                    .filter(item => {
                                        // Verificar sucursal
                                        let branchMatch = true 
                                        if( branchSelected !== undefined && branchSelected !== null ){
                                            branchMatch = item.branch.id === branchSelected  ? true : false
                                        }

                                        // Verificar moneda
                                        let currencyMatch = true
                                        if(values?.currency !== undefined && values?.currency !== null ){
                                            currencyMatch = item.currency.id === Number(values.currency) ? true : false
                                        }
                                        return branchMatch && currencyMatch;
                                    })
                                    .map((item) => (
                                    <Option value={item.id} key={item.id}  currency={item.currency.id} sign={item.currency.sign}>
                                        {item.name}
                                    </Option>
                                ))} 
                            </Select>                     
                        </Form.Item>  
                        </Col>
                    </Row> 
                    <Form.Item
                        label='Monto'
                        name='amount'
                        rules={[
                            {
                                required: true,
                                message:'Este campo es obligatorio'
                            }
                        ]}
                    >
                        <InputNumber
                            disabled={disabledForm.disable}
                            addonBefore={currency ? currency.sign : ' ¤ '} 
                            placeholder="Monto"
                            onChange={onChangeAmount}
                            formatter={value =>
                            value
                                ? new Intl.NumberFormat('es-AR', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 20
                                }).format(Number(value))
                                : ''
                            }
                            onKeyDown={changePoint}
                            parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                            stringMode
                        />
                    </Form.Item>  
                    {
                        showAddMovements === undefined && 
                        <Checkbox
                            style={{width: '100%', marginBottom: 15}}
                            disabled={disabledForm.disable}
                            checked={withComission}
                            onChange={onChangeComissionCheck}
                                
                        >
                            Agregar Comisión
                        </Checkbox> 
                    }                                                                          
                    {
                        withComission &&
                        <Row 
                            style={{
                                display: 'flex',
                                justifyContent:'space-between'
                            }}
                        >
                            <Row
                                style={{position:'relative'}} 
                            >
                                 {isFixedCommission && 
                                    <Row
                                        onClick={()=>{
                                            setIsFixedCommission(false)
                                            //setComission(0)
                                            setTimeout(() => {
                                                inputRefPorcentage.current?.focus(); // Enfoca después de renderizar 
                                                form.setFieldsValue({ fixed_commission: 0 });                                            
                                            }, 0);
                                        }}
                                        style={{
                                            cursor:'pointer', 
                                            height: '100%', 
                                            width: '100%', 
                                            position: 'absolute', 
                                            zIndex:1000,
                                        }}
                                    >
                                    </Row>
                                }
                                <Form.Item
                                    label='Comisión %'
                                    name='commission'
                                    initialValue={3}
                                    rules={[
                                        {
                                            required: true,
                                            message:'Este campo es obligatorio'
                                        }
                                    ]}
                                >
                                    <InputNumber 
                                        ref={inputRefPorcentage}
                                        disabled={disabledForm.disable || isFixedCommission }
                                        addonBefore={'%'} 
                                        //onChange={onChangeComission}
                                        placeholder="Comisión %"
                                        onClick={()=>setIsFixedCommission(false)}
                                        formatter={value =>
                                        value
                                            ? new Intl.NumberFormat('es-AR', {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 20
                                            }).format(Number(value))
                                            : ''
                                        }
                                        onKeyDown={changePoint}
                                        parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                                        stringMode
                                    />
                                </Form.Item>
                            </Row>                            
                            <Row
                               style={{position:'relative'}} 
                            >
                                {!isFixedCommission && 
                                    <Row
                                        onClick={()=>{
                                            setIsFixedCommission(true)
                                            setTimeout(() => {
                                                inputRef.current?.focus(); // Enfoca después de renderizar
                                                form.setFieldsValue({ commission: 0 });
                                                //setComission(0)
                                            }, 0);
                                        }}
                                        style={{
                                            cursor:'pointer', 
                                            height: '100%', 
                                            width: '100%', 
                                            position: 'absolute', 
                                            zIndex: 1000,
                                        }}
                                    >
                                    </Row>
                                }
                                <Form.Item
                                    label='Comisión por monto'
                                    name='fixed_commission'  
                                    initialValue={0}
                                >                                    
                                    <InputNumber                                        
                                        ref={inputRef}
                                        disabled={disabledForm.disable || !isFixedCommission}
                                        addonBefore={currency ? currency.sign : ' ¤ '} 
                                        placeholder="Monto"
                                        formatter={value =>
                                        value
                                            ? new Intl.NumberFormat('es-AR', {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 20
                                            }).format(Number(value))
                                            : ''
                                        }
                                        onKeyDown={changePoint}
                                        parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                                        stringMode
                                    />                                                                
                                </Form.Item>
                            </Row> 
                        </Row>                        
                    } 
                    {
                        withComission &&
                        <Form.Item
                            label='Costos Bancarios'
                            name='transfer_costs'
                            initialValue={costBank}                                                        
                        >
                            <InputNumber
                                disabled={disabledForm.disable}
                                onChange={onChangeCostBank}
                                placeholder="0"
                                addonBefore={currency ? currency.sign : ' ¤ '} 
                                formatter={(value) =>
                                value
                                    ? new Intl.NumberFormat('es-AR', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 20
                                    }).format(Number(value))
                                    : ''
                                }
                                onKeyDown={changePoint}
                                parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                                stringMode
                            />
                        </Form.Item>
                    }                                                                                             
                    {
                        withComission &&
                        <Row style={{marginBottom: 15, fontWeight: 700}}>
                            <span style={{marginRight:10}}>
                                {typeTrasnfer === 'deposit' && 'Acreditación en cuenta cliente:'}
                                {typeTrasnfer === 'extraction' && 'Débito en cuenta cliente:'} 
                            </span>
                            <span>{currency && currency.sign}</span>
                            <span>{results?.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>  
                        </Row>                                                                       
                    }
                    {
                        withComission &&                        
                        <Checkbox
                            style={{width: '100%', marginBottom: 15}}
                            disabled={disabledForm.disable}
                            checked={clientPayCost}
                            onChange={onChangePayCost}
                                
                        >
                            Cliente paga los costos
                        </Checkbox>                        
                    }
                    <Checkbox
                        
                        style={{width: '100%', marginBottom: 15}}
                        disabled={disabledForm.disable}
                        checked={aproved}
                        onChange={onChangeAproved}
                    >
                        Aprobado
                    </Checkbox>
                    <Form.Item
                        label='Descripción'
                        name='description'
                    >
                        <Input
                            disabled={disabledForm.disable}
                            placeholder="Comentario"
                        />
                    </Form.Item>                                        
                    <span style={{color: '#FFA500', fontWeight: '500'}}>{spanError && `Notificación: ${spanError}`} </span>                              
                </Form>
            </Modal>
        </div>
    )
}

export default DepositExtractionForm;
